export default __webpack_public_path__ + "static/media/hzd1.38bc6b2d.svg";